import { render } from "./IconStatut.vue?vue&type=template&id=21e1636e"
const script = {}

import exportComponent from "/home/romych/projects/vue.home.zina.design/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__